import { AsyncSelect, type IAsyncSelectProps } from '@procurify/ui'

import { primaryCategoryRepository } from '@webapp/core/data-access/repositories/PrimaryCategoryRepository'
import type { RequestTypeEnum } from '@webapp/core/entities/internal/enums/RequestTypeEnum'
import { PrimaryCategory } from '@webapp/core/entities/internal/PrimaryCategory'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

interface IPrimaryCategoryProps extends IAsyncSelectProps<PrimaryCategory> {
  /** Request primary categories available to a specific user by ID and request type */
  userId?: number
  requestType?: RequestTypeEnum
  /** Scope primary categories to a legal entity */
  legalEntityId?: number
}

export const PrimaryCategorySelect = ({
  userId,
  requestType,
  legalEntityId,
  ...props
}: IPrimaryCategoryProps) => {
  const intl = useProcurifyIntl()

  const loadOptions: IPrimaryCategoryProps['loadOptions'] = (
    inputValue,
    pagination,
    callback
  ) => {
    primaryCategoryRepository
      .list({
        userId,
        requestType,
        legalEntityId,
        search: inputValue,
        page: pagination.page,
      })
      .then((res) => {
        callback({
          options: res.data.map(
            (primaryCategory) => new PrimaryCategory(primaryCategory)
          ),
          pagination: {
            hasMore: res.pagination
              ? res.pagination?.page < res.pagination?.numPages
              : false,
            page: pagination.page + 1,
          },
        })
      })
  }

  return (
    <AsyncSelect<PrimaryCategory>
      cacheOptions={true}
      loadOptions={loadOptions}
      placeholder={intl.formatMessage(messages.placeholderText)}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id.toString()}
      {...props}
    />
  )
}
